import { generateSeoProps } from '../generateSeoProps';
export const getCartSeoProps = () => {
	return generateSeoProps({ title: 'Pharmuni | Cart', canonical: 'cart' });
};
